import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "recharts";
import { IconWithBg } from "../../styles/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styled from "styled-components";
import BackdropWrapper from "../modals/BackdropWrapper";
import ShareRecipe from "../modals/ShareRecipe";
import QuickAddRecipe from "../modals/QuickAddRecipe";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../authentication/firebase";
import { useDispatch, useSelector } from "react-redux";
import { alertActions } from "../../store/alertSlice";
import { CircularProgress } from "@mui/material";

export default function RecipeOptionsIcon({
  recipeData,
  servings,
  selectedDate,
  handleBackdrop,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [shareBackdrop, setShareBackdrop] = useState(false);
  const [quickAddBackdrop, setQuickAddBackdrop] = useState(false);
  const [deleteRecipeLoading, setDeleteRecipeLoading] = useState(false);

  const boxRef = useRef();
  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state.user.info.isAdmin);

  function iconClickHandler() {
    setMenuOpen((current) => !current);
  }
  const shareRecipeHandler = () => {
    setMenuOpen(false);
    setShareBackdrop((prev) => !prev);
  };
  const quickAddRecipeHandler = () => {
    setMenuOpen(false);
    setQuickAddBackdrop((prev) => !prev);
  };

  async function deleteRecipeHandler() {
    setDeleteRecipeLoading(true);
    try {
      await deleteDoc(
        doc(db, `${recipeData.recipeType}Recipes`, recipeData.id)
      );
      dispatch(
        alertActions.setAlert({
          title: "Success! Refresh to see changes",
          messageType: "success",
        })
      );
      handleBackdrop();
    } catch (e) {
      dispatch(
        alertActions.setAlert({
          title: "Recipe deletion unsuccessful",
          messageType: "error",
        })
      );
      console.log("error while deleting recipe", e);
    } finally {
      setDeleteRecipeLoading(false);
    }
  }

  const options = [
    { name: "Share", clickHandler: shareRecipeHandler },
    { name: "Add to Calendar", clickHandler: quickAddRecipeHandler },
  ];
  if (isAdmin) {
    options.push({
      name: deleteRecipeLoading ? (
        <>
          <p>Delete</p>
          <CircularProgress
            style={{
              color: "var(--text-light-color)",
              width: 16,
              height: 16,
            }}
          />
        </>
      ) : (
        "Delete"
      ),
      clickHandler: deleteRecipeHandler,
    });
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        // Clicked outside the box
        setMenuOpen(false);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <StyledOptions>
      <BackdropWrapper
        smallSize={true}
        open={shareBackdrop}
        handleBackdrop={shareRecipeHandler}
        element={
          <ShareRecipe
            recipeData={recipeData}
            handleBackdrop={shareRecipeHandler}
          />
        }
      />
      <BackdropWrapper
        open={quickAddBackdrop}
        handleBackdrop={quickAddRecipeHandler}
        smallSize={true}
        element={
          <QuickAddRecipe
            data={recipeData}
            selectedServings={servings}
            handleBackdrop={quickAddRecipeHandler}
            selectedDate={selectedDate}
          />
        }
      />
      <div ref={boxRef}>
        <IconWithBg onClick={iconClickHandler}>
          <MoreVertIcon htmlColor="var(--text-color)" />
        </IconWithBg>
        <div className={`dropdown-content ${menuOpen ? "active" : ""}`}>
          {options.map((option, index) => (
            <p key={index} onClick={option.clickHandler}>
              {option.name}
            </p>
          ))}
        </div>
      </div>
    </StyledOptions>
  );
}

const StyledOptions = styled.div`
  padding: 4px 8px;
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius: 8px;
    padding: 6px;
    p {
      cursor: pointer;
      margin: 6px 0;
      font-weight: 500;
      font-family: "Poppins";
      display: flex;
      align-items: center;
      gap: 10px;
      height: 26px;
      &:hover {
        color: var(--primary-color);
      }
    }
  }
  .active {
    display: block;
  }
`;
